import styled from 'styled-components';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import logoCapemisaSeguradora from '../../../imagens/logo-capemisa-seguradora.png';
import {Link} from 'react-router-dom';

//------------------------------------------------------------------//


export const PageSpace = styled.div`
    width:fit-content;
    min-height:500px;
    min-width:520px;
    max-width:100%;
    padding-bottom:10px;
`
export const TopRounded = styled.div`
    width:100%;
    border:1px solid #B9B9B9;
    border-radius:9px;
    display:flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0px;
    padding-left: 25px;
`
export const TextSuspended = styled.div<{width?:string}>`
    display:flex;
    flex-direction:column;
    width:${props=>props.width??"48%"};
`
export const InsideRowColumnName = styled.div`
    text-align: left;
    font: 0.9em Roboto;
    letter-spacing: -0.34px;
    color: #B9B9B9;
    opacity: 1;
    margin-bottom:0px;
`
export const InsideSelectedText = styled.label`
    margin-bottom:0px;
    margin-top:5px;
    text-align: left;
    font: 1em Roboto;
    letter-spacing: -0.38px;
    color: #636363;
    opacity: 1;
`
export const TopRoundedRow = styled.div`
    margin-top:5px;
    min-height:40px;
    width:100%;
    display:flex;
    justify-content:space-between;
`
export const TopRoundedFooter = styled.div`
    margin-top:20px;
    padding-left:5px;
    padding-right:5px;
`
export const SingleLine = styled.div`
    display:flex;
    flex-direction:row;
    width:100%;
    justify-content:space-between;
`
export const AlignSpace = styled.div`
    display:flex;
    flex-direction:column;
    width:100%;
`
export const RowsSpacer = styled.div`
    width:100%;
    height:fit-content;
    padding:10px 0px;
    display:flex;
    flex-direction:column;
`
export const Icon = styled(FontAwesomeIcon)`
    font-size:15px;
    margin-right:2px;
    cursor:pointer;
`
export const DropdownSpace = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    width:100%;
    padding:10px 0px;
`
export const EnviarDocumentosButton = styled.button<{buttonSize?:"default"|"big",canSend?:boolean}>`
    ${props=>props.canSend?"background: #E27800 0% 0% no-repeat padding-box;letter-spacing: 0px;color: #FFFFFF;cursor:pointer;"
    :"background: #D8D8D8 0% 0% no-repeat padding-box;text-align: left;font: normal normal bold 13px/18px Roboto;letter-spacing: 0px;color: #FFFFFF;opacity: 1;cursor:auto!important;"}
    
    ::after, ::before, :focus{
        outline:0px;
    };
    ${props=>props.buttonSize==="big"?"min-width:300px;max-width:400px;border-radius:7px;":"min-width:200px;max-width:300px;border-radius:5px;"}
    border:0;
    margin-top:10px;
    min-height:30px;
    text-align:center;
`
export const NavigationButtonsSpace = styled.div`
    display:flex;
    flex-direction:row-reverse;
    margin-top:10px;
`

export const OrangeLink=styled(Link)`
   color:#E27800;
`;
export const BtnOutlineLaranja=styled(Link)`
    height:40px;
    border-radius:21px;
    background-color:transparent; 
    border:2px solid #E27800;
    font-size:1em;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    color:#E27800;
    font-family:Roboto;
    width:32%;
    text-decoration: none;
    &:focus, &:hover, &:visited, &:link, &:active {
        color:#E27800;
        text-decoration: none;
    }
    ::after, ::before, :focus{
        outline:0px;
    };
`;

export const ModalBody = styled.div`
    height:100%;
    min-height:200px;
    width:300px;
    display:flex;
    flex-direction:column;
    padding:10px;
    justify-content:space-between;
`
export const WarningMessage = styled.label`
    text-align: center;
    font: normal normal bold 16px Roboto;
    letter-spacing: 0px;
    color: #E27800;
    opacity: 1;
`
export const BodyText = styled.label`
    text-align: center;
    font: normal normal normal 14px Roboto;
    letter-spacing: 0px;
    color: #636363;
`
export const MiniButtonsSpace = styled.div`
    width:100%;
    display:flex;
    justify-content: space-around;
`
export const MiniGreyButton = styled.button`
    border-radius:21px;
    background-color:#DADADA; 
    border:none;
    font-size:1em;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    color:#707070;
    font-family:Roboto;
    width:32%;
    text-decoration: none;
    height:25px;
    padding:0px 10px;
`
export const MiniOrangeButton = styled.button`
    height: 25px;
    background-color: #E27800;
    border-radius: 21px; 
    border: none; 
    font-size:1em;
    color: #FFFFFF;
    width:54%;
    ::after, ::before, :focus{
        outline:0px;
    }; 
    margin-left:10px;
`
export const PrintDocsLabel = styled.div`
    color:${props=>props.theme.cores.primaria};
    font-size:1em;
    display: inline-block;
    :hover{
        cursor:pointer;
        text-decoration:underline;
    }
    padding-left: 300px;
    font-weight: bold;
`

export const PrintBackdrop = styled.div`
    width:100%;
    display:flex;
    justify-content: center;
    align-items: center;
`
export const PrintInsideSpace = styled.div`
    width:70%;
    height:max-content;
`

export const CapemisaImage = styled.div`
    background-image:url(${logoCapemisaSeguradora});
    height:100px;
    width:100%;
    margin-top:40px;
    background-size: contain;
    background-repeat: no-repeat;
    border-bottom:2px solid #E2B500;
`

export const Switch = styled.label`
    position: relative;
    display: inline-block;
    width: 60px;
    height: 24px;
`

export const Checkbox = styled.input`
    opacity: 0;
    width: 0;
    height: 0;
`

export const Slider = styled.span<{checked?:boolean}>`
    & {
        position: absolute;
        cursor: pointer;
        border-radius: 34px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        //background-color: none;
        //border: 2px solid #636363;
        background-color: ${props => props.checked ? "#E27800" : "none" };
        border: ${props => props.checked ? "2px solid #E27800" : "2px solid #636363" };
        -webkit-transition: .4s;
        transition: .4s;
        transform: scale(0.8);
    }

    &:before {
        position: absolute;
        content: "";
        border-radius: 50%;
        height: 13px;
        width: 13px;
        top: 3px;
        left: 3px;
        bottom: 4px;
        /* background-color: #636363; */
        background-color: ${props => props.checked ? "white" : "#636363"};
        -webkit-transform: ${props => props.checked ? "translateX(36px)" : "translateX(0px)" };
        -ms-transform: ${props => props.checked ? "translateX(36px)" : "translateX(0px)" };
        transform: ${props => props.checked ? "translateX(36px)" : "translateX(0px)" };

        -webkit-transition: .4s;
        transition: .4s;
    }

    /* ${Checkbox}:checked + & {
        background-color: #E27800;
        border: 2px solid #E27800;
    }

    ${Checkbox}:checked + &:before {
        -webkit-transform: translateX(36px);
        -ms-transform: translateX(36px);
        transform: translateX(36px);
        background-color: white;
    }  */
`

export const BtnLaranja=styled.button`
    display: inline-block;
    margin-left: 20px;
    height: 40px;
    background-color: #E27800;
    border-radius: 10px; 
    border: none; 
    font-size:1em;
    color: #FFFFFF;
    width:90px;
    ::after, ::before, :focus{
        outline:0px;
    }; 
    margin-left:10px;
`

export const BtnLaranjaSend=styled.button<{marginLeft?:string}>`
    height: 40px;
    margin-left: ${props=>props.marginLeft??'460px'};
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #E27800;
    border-radius: 21px; 
    border: none; 
    font-size:0.8em;
    color: #FFFFFF;
    width:40%;
    ::after, ::before, :focus{
        outline:0px;
    };
`;

export const BtnCinza=styled.button`
    height:40px;
    margin-left: 460px;
    border-radius:21px;
    background-color:#DADADA; 
    border:none;
    font-size:0.8em;
    color:#707070;
    font-family:"Roboto";
    width:40%;
    ::after, ::before, :focus{
        outline:0px;
    };
`;
